import { Brain, Zap, Leaf, Sparkles } from "lucide-react";

const iconMap = {
  brain: Brain,
  zap: Zap,
  leaf: Leaf,
  sparkles: Sparkles
};

const IngredientsSection = ({ ingredients }) => {
  return (
    <section 
      className="py-20 md:py-28 bg-nukleus-card"
      data-testid="ingredients-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-nukleus-lilac mb-4 block">
            Science-Backed Formula
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-4">
            What's Inside
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto">
            Every ingredient is clinically studied and precision-dosed for maximum efficacy.
          </p>
        </div>

        {/* Ingredients Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {ingredients.map((ingredient, index) => {
            const IconComponent = iconMap[ingredient.icon] || Brain;
            
            return (
              <div
                key={index}
                className="group relative bg-nukleus-bg rounded-2xl p-6 md:p-8 border border-white/5 hover:border-nukleus-violet/30 transition-all duration-300 card-hover"
                data-testid={`ingredient-${index}`}
              >
                <div className="flex items-start gap-5">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-nukleus-violet/10 flex items-center justify-center shrink-0 group-hover:bg-nukleus-violet/20 transition-colors">
                    <IconComponent className="w-6 h-6 text-nukleus-violet" />
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <h3 className="text-xl font-semibold text-white">
                        {ingredient.name}
                      </h3>
                      <span className="text-sm font-bold text-nukleus-lilac bg-nukleus-lilac/10 px-3 py-1 rounded-full">
                        {ingredient.dose}
                      </span>
                    </div>
                    
                    <p className="text-sm font-medium text-nukleus-violet mb-3">
                      {ingredient.benefit}
                    </p>
                    
                    <p className="text-white/50 text-sm leading-relaxed">
                      {ingredient.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IngredientsSection;
